export default "__VITE_ASSET__DhSeA62A__"